import { useEffect, useState } from 'react';

export const useDownloadFile = (url: string) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(false);
  const [file, setFile] = useState<string | null>(null);

  useEffect(() => {
    setDownloading(true);
    setError(false);

    fetch(url, {
      credentials: 'same-origin',
    })
      .then((response) => response.text())
      .then((text) => {
        const base64Svg = btoa(unescape(encodeURIComponent(text)));
        setFile(`data:image/svg+xml;base64,${base64Svg}`);
        setDownloading(false);
        setError(false);
      })
      .catch(() => {
        setDownloading(false);
        setError(true);
      });
  }, [url]);

  return {
    downloading,
    error,
    file,
  };
};
